var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors && _vm.errors.length)?_c('span',[_c('small',{staticClass:"argon-error",domProps:{"textContent":_vm._s(_vm.errors[0])}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }